import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { LoadableAfterPaint } from '@confluence/loadable';

const SmartCreationModalLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartCreationModal" */
				'@confluence/smart-create/entry-points/smartCreationModal.tsx'
			)
		).ConfluenceSmartCreationModalLoader,
});

export const SmartCreationComponentLoader = (): React.JSX.Element | null => {
	return (
		<ErrorBoundary
			attribution={Attribution.SMARTS}
			attributes={{
				errorBoundaryId: 'GlobalComponents-Smarts',
			}}
		>
			<SmartCreationModalLoadable />
		</ErrorBoundary>
	);
};
